import produce from "immer";
import { IStoreState } from "../../initialStoreState";
import { LoadState } from "../../../constants/enums";
import { initialTestOneState } from "./testOne.types";
import { CLEAR_TEST_ONE_STATE, FETCH_TEST_ONE_LIST_FAILURE, FETCH_TEST_ONE_LIST_PROGRESS, FETCH_TEST_ONE_LIST_SUCCESS } from "./testOneActions";
import { TestOneActions } from ".";


export const testOneReducer = (
  state: IStoreState["accounting"]["testOne"] = initialTestOneState,
  action: TestOneActions
) => {
  switch (action.type) {
	case FETCH_TEST_ONE_LIST_PROGRESS: {
	  const newState = produce(state, (draftState) => {
		draftState.loading = LoadState.InProgress;
	  });
	  return newState;
	}

	case FETCH_TEST_ONE_LIST_SUCCESS: {
	  const { list } = action.payload;
	  const newState = produce(state, (draftState) => {
		draftState.loading = LoadState.Loaded;
		draftState.list = list;
	  });
	  return newState;
	}

	case FETCH_TEST_ONE_LIST_FAILURE: {
	  const newState = produce(state, (draftState) => {
		draftState.loading = LoadState.Failed;
	  });
	  return newState;
	}

	case CLEAR_TEST_ONE_STATE: {
	  return initialTestOneState;
	}

	default:
	  return state;
  }
};
